import { mapState } from 'vuex';
import { getRuleDescription } from './Utils/labels';
export default {
  name: 'SearchTagList',
  props: {
    rules: {
      type: Array,
      required: true,
      default: () => []
    },
    searchConfig: {
      type: Object,
      required: true,
      default: () => ({})
    },
    small: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapState('app', ['color'])
  },
  methods: {
    getRuleCategoryWithCondition(rule) {
      const {
        categoryLabel,
        conditionLabel
      } = getRuleDescription(rule, this.$i18n, this.searchConfig);
      return `${categoryLabel} ${conditionLabel}`;
    },
    getRuleValue(rule) {
      const {
        valueLabel
      } = getRuleDescription(rule, this.$i18n, this.searchConfig);
      return valueLabel;
    },
    removeRule(index) {
      this.$emit('remove', index);
    }
  }
};